import { useTheme } from "./ThemeContext";

function DarkModeToggle({
  className = "",
  showLabel = true,
  labelClassName = "",
}) {
  const { isDark, toggleTheme } = useTheme();

  return (
    <div
      className={`bloom-switch-row ${className}`.trim()}
      onClick={(e) => e.stopPropagation()}
    >
      <label className="bloom-switch" aria-label="Toggle night mode">
        <input
          type="checkbox"
          checked={isDark}
          onChange={toggleTheme}
          aria-checked={isDark}
        />
        <span className="bloom-switch__track">
          <span className="bloom-switch__star bloom-switch__star--1" />
          <span className="bloom-switch__star bloom-switch__star--2" />
          <span className="bloom-switch__star bloom-switch__star--3" />
          <span className="bloom-switch__thumb">
            <svg
              className="bloom-switch__sun"
              viewBox="0 0 256 256"
              aria-hidden="true"
            >
              <path
                fill="currentColor"
                d="M120,40V16a8,8,0,0,1,16,0V40a8,8,0,0,1-16,0Zm72,88a64,64,0,1,1-64-64A64.07,64.07,0,0,1,192,128Zm-16,0a48,48,0,1,0-48,48A48.05,48.05,0,0,0,176,128ZM58.34,69.66A8,8,0,0,0,69.66,58.34l-16-16A8,8,0,0,0,42.34,53.66Zm0,116.68-16,16a8,8,0,0,0,11.32,11.32l16-16a8,8,0,0,0-11.32-11.32ZM192,72a8,8,0,0,0,5.66-2.34l16-16a8,8,0,0,0-11.32-11.32l-16,16A8,8,0,0,0,192,72Zm5.66,114.34a8,8,0,0,0-11.32,11.32l16,16a8,8,0,0,0,11.32-11.32ZM48,128a8,8,0,0,0-8-8H16a8,8,0,0,0,0,16H40A8,8,0,0,0,48,128Zm80,80a8,8,0,0,0-8,8v24a8,8,0,0,0,16,0V216A8,8,0,0,0,128,208Zm112-88H216a8,8,0,0,0,0,16h24a8,8,0,0,0,0-16Z"
              />
            </svg>
            <svg
              className="bloom-switch__moon"
              viewBox="0 0 256 256"
              aria-hidden="true"
            >
              <path
                fill="currentColor"
                d="M233.54,142.23a8,8,0,0,0-8-2,88.08,88.08,0,0,1-109.8-109.8,8,8,0,0,0-10-10,104.84,104.84,0,0,0-52.91,37A104,104,0,0,0,136,224a103.09,103.09,0,0,0,62.52-20.88,104.84,104.84,0,0,0,37-52.91A8,8,0,0,0,233.54,142.23Z"
              />
            </svg>
          </span>
        </span>
      </label>
      {showLabel && (
        <span className={`bloom-switch-label ${labelClassName}`.trim()}>
          {isDark ? "Dark mode" : "Light mode"}
        </span>
      )}
    </div>
  );
}

export default DarkModeToggle;
